import { useCallback } from 'react';
import { FetchElements, GetCookie } from "../../js/request";
import { REQUEST, GET_SELECTED_SHOP_ID } from "../../js/Const";

export const useSetStatIsExist = (navigate, showAlert) => {

    const setStatIsExist = useCallback(() => {
        return new Promise((resolve, reject) => {
            const selectedId = GET_SELECTED_SHOP_ID();
            const accessToken = GetCookie("access_token");

            if (!selectedId || selectedId === 0 || !accessToken) {
                reject(new Error('ID магазина или токен не найден'));
                return;
            }

            const url = `${REQUEST}/api/v1/tasks/set_stat_is_exist?shops_id=${selectedId}`;

            FetchElements(
                url,
                'GET',
                (data) => {
                    resolve(data);
                },
                navigate,
                2,
                () => {
                    reject(new Error('Ошибка навигации'));
                },
                (title, message, status) => {
                    if (showAlert) {
                        showAlert(title, message, status);
                    } else {
                        console.error(`${title}: ${message}`);
                    }
                    reject(new Error(message));
                },
                0,
                null,
                [],
                false
            );
        });
    }, [navigate, showAlert]);

    return { setStatIsExist };
};